/* eslint-disable
    func-names,
    no-shadow,
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
require('./documentUpload.scss');
require('ng-file-upload');

const deps = [
  'ngFileUpload',
  require('angular-ui-router'),
  require('data/model/file').name,
  require('data/collection/document').name,
  require('ui/web/notifications').name,
  require('data/user').name,
  require('ui/web/dragAndDropDisplay').name,
];

module.exports = angular
  .module('bench.ui.documentUpload', deps)

  .directive('blDocumentUpload', ($compile, _) => ({
    restrict: 'A',
    scope: {
      fileId: '=',
      origin: '@',
      documentsId: '=',
      documentType: '@',
      dragAndDrop: '=',
      onComplete: '=',
    },
    bindToController: true,
    controller: require('./documentUploadCtrl.coffee'),
    controllerAs: 'vm',
    compile(elem, attrs) {
      // necessary to avoid infinite compile loop
      elem.removeAttr('bl-document-upload');
      _.map(
        {
          'ngf-select': '',
          'ng-model': 'vm.rawFile',
          multiple: 'true',
        },
        (val, attr) => elem.attr(attr, val),
      );

      return function (scope, elem, attrs) {
        const link = $compile(elem)(scope);

        if (scope.vm.dragAndDrop) {
          const template = require('./documentUpload.html');
          const $dragAndDrop = $compile(template)(scope);
          return elem.append($dragAndDrop);
        }
      };
    },
  }));
